import BookGroup from './groups/BookGroup';
import ConfucioGroup from './groups/ConfucioGroup';
import CatGroup from './groups/CatGroup';
import ComputerGroup from './groups/ComputerGroup';
import GhostGroup from './groups/GhostGroup';
import HamburgerGroup from './groups/HamburgerGroup';
import PolaroidGroup from './groups/PolaroidGroup';
import RocketGroup from './groups/RocketGroup';
import UfoGroup from './groups/UfoGroup';


const groupsMap = new Map();

groupsMap.set('book', BookGroup);
groupsMap.set('confucio', ConfucioGroup);
groupsMap.set('cat', CatGroup);
groupsMap.set('computer', ComputerGroup);
groupsMap.set('ghost', GhostGroup);
groupsMap.set('hamburger', HamburgerGroup);
groupsMap.set('polaroid', PolaroidGroup);
groupsMap.set('rocket', RocketGroup);
groupsMap.set('ufo', UfoGroup);

export default groupsMap;
